import styled from 'styled-components'
import styles from '../../utility/styles'
import Text from '../shared/Text'
import { Col, Row } from 'react-bootstrap'
import { MayorIcon, CICIcon, ZapperIcon } from '../../utility/icons'

const convertTitle = title => {
	const arr = title.split('_')
	return arr
		.map(word =>
			word
				.split('')
				.map((letter, i) => (i === 0 ? letter.toUpperCase() : letter))
				.join('')
		)
		.join(' ')
}

const Icon = ({ type }) => {
    switch(type) {
        case 'mayor':
            return <MayorIcon />
        case 'charger_in_charge':
            return <CICIcon />
        case 'zapper':
            return <ZapperIcon />
        default:
            return false
    }
}

const Wrapper = styled.div`
	padding-bottom: 38px;
	border-bottom: 1px solid var(--tz-hairline, rgba(255, 255, 255, 0.08));
`

const StyledRow = styled(Row)``

const StyledCol = styled(Col)`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	@media only screen and (max-width: 768px) {
		flex-direction: row;
		align-items: center;
	}
`

const AvatarRow = styled.div`
	display: flex;
	align-items: center;
	align-self: center;
	margin-bottom: 12px;
`

const InfoCol = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	@media only screen and (max-width: 768px) {
		flex: 1;
		align-items: flex-end;
	}
`

const Avatar = styled.img`
	height: 64px;
	width: 64px;
	border-radius: 32px;
    z-index: 100;
`

const NoImage = styled.div`
	height: 64px;
	width: 64px;
	border-radius: 32px;
	z-index: 100;
	border: 3px solid ${styles.colors.blue};
	background-color: var(--tz-surface-raised, #1A202C);
	display: flex;
	align-items: center;
	justify-content: center;
`

const StyledSpan = styled.span`
	font-weight: bold;
`

const IconWrapper = styled.div`
    display: flex;
    width: 64px;
    height: 64px;
    border-radius: 32px;
    background-color: var(--tz-surface-raised, #1A202C);
    align-items: center;
    justify-content: center;
    margin-left: -12px;
`

export default function Awards({ awards = [] }) {

	return (
		<Wrapper>
			<Text.Heading
				type='h5'
				variant='bold'
				style={{ marginBottom: '24px' }}
			>
				Awards
			</Text.Heading>
			<StyledRow className='container-fluid'>
				{awards?.map(({ award, name, avatar }) => (
					<StyledCol key={award} md={4} sm={12}>
						<AvatarRow>
							{avatar ? (
								<Avatar src={avatar} />
							) : (
								<NoImage>
									<Text.Caption variant='bold' color={styles.colors.blue}>{name}</Text.Caption>
								</NoImage>
							)}
							<IconWrapper>
                                <Icon type={award} />
                            </IconWrapper>
						</AvatarRow>
						<InfoCol>
							<Text.Body variant='bold' style={{ textAlign: 'center' }}>
								{convertTitle(award)}
							</Text.Body>
							<Text.Tiny style={{ textAlign: 'center' }}>
								<StyledSpan>{name} </StyledSpan>
								{award.award_string}
							</Text.Tiny>
						</InfoCol>
					</StyledCol>
				))}
			</StyledRow>
		</Wrapper>
	)
}
